import { useDataChange } from 'Simple/Data.js'
export function useOnClick(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'event_action',
    path: 'actions',
  })
  return function onClick() {
    change([])
  }
}
